import classNames from "classnames";
import React, { useEffect, useRef } from "react";
import { Svg } from "../../../../Shared/Assets/Svg/React";
import { Popover } from "../../../../Shared/Popover/React";
import { ProvetDepartment } from "../../types";
import { DepartmentListItem } from "./departmentListItem";

interface DepartmentMarkerProps {
  department: ProvetDepartment;
  onSelectDepartment: (department: ProvetDepartment) => void;
  oldBookingDomain?: string;
}

interface ExtendedMarkerElement extends HTMLDivElement {
  __onSelectDepartment?: (department: ProvetDepartment) => void;
  __department?: ProvetDepartment;
}

export const DepartmentMarker = ({
  department,
  onSelectDepartment,
  oldBookingDomain
}: DepartmentMarkerProps) => {
  // Store the onSelectDepartment callback on the marker element so it can be called later
  const markerRef = useRef<ExtendedMarkerElement>(null);

  useEffect(() => {
    if (markerRef.current) {
      // Store the callback as a property on the DOM element
      markerRef.current.__onSelectDepartment = onSelectDepartment;
      markerRef.current.__department = department;
    }
  }, [onSelectDepartment, department]);

  return (
    <div
      ref={markerRef}
      aria-controls={`department-popover-${department.id}`}
      className={classNames(
        "flex flex-col w-2xl h-2xl justify-center items-center gap-[0.0625rem] transition-short-in-out",
        "text-neutral-0 bg-dark-blue-600 rounded-full shadow-md",
        "hover:bg-dark-blue-400",
        "focus-outline [*:focus-visible_&]:outline-4 [*:focus-visible_&]:outline-dark-blue-400",
        "aria-expanded:outline-4 aria-expanded:outline-turquoise-800"
      )}
      id={`department-marker-${department.id}`}
      role="button"
      data-department-id={department.id}
    >
      <Svg href="/svg/system/clinic.svg" additionalClass="flex-none fill-neutral-0" />

      <div className="flex gap-[0.125rem] justify-center"></div>

      <Popover
        anchorId="provet-department-finder-map-popover-anchor"
        id={`department-popover-${department.id?.toString() ?? ""}`}
        title={department.name ?? ""}
      >
        <DepartmentListItem
          vertical
          department={department}
          onSelectDepartment={onSelectDepartment}
          oldBookingDomain={oldBookingDomain}
        />
      </Popover>
    </div>
  );
};
